/**
 * Costanti per le azioni del modulo flyers (bulk selector, etc.)
 * @module flyers/constants/actions
 */

/**
 * Azioni disponibili per la modifica bulk
 */
export const ACTIONS = {
    SKIP: "skip",
    SET: "set",
    ADD: "add",
    CLEAR: "clear",
};

/**
 * Formato data per il campo sellout
 */
export const DATE_FIELD_FORMAT = "YYYY-MM-DD";
export const SELL_OUT_FORMAT = DATE_FIELD_FORMAT;
